window.CartUpsell = (() => {
    "use strict";
    console.log("Cart Upsell JS loaded");

    const HAMPER_CONFIG = {
        variantId: 46546287329382,
        idKey: "_hamper_id",
        parentKey: "_hamper_parent"
    };

    function isHamperParent(item) {
        return !!(item?.properties && item.properties[HAMPER_CONFIG.idKey]);
    }

    function isHamperChild(item) {
        return !!(item?.properties && item.properties[HAMPER_CONFIG.parentKey]);
    }

    async function getCart() {
        const response = await fetch("/cart.js", {
            method: "GET",
            headers: {
                "Accept": "application/json"
            },
            cache: "no-store"
        });
        if (!response.ok) {
            throw new Error("Failed to get cart");
        }
        return await response.json();
    }
    function updateUpsellUI(cart) {
        if (!cart?.items) return;
        const cartProductIds = new Set(
            cart.items.map(item => String(item.product_id))
        );

        document.querySelectorAll(".cart-upsell-wrapper").forEach(wrapper => {
            let visibleCount = 0;

            wrapper.querySelectorAll(".cart-upsell__card").forEach(card => {
                const productId = card.dataset.upsellProductId;
                const inCart = cartProductIds.has(productId);

                card.style.display = inCart ? "none" : "";
                card.classList.remove("is-adding");

                const checkbox = card.querySelector(".cart-upsell__checkbox");
                if (checkbox) {
                    checkbox.checked = false;
                    checkbox.disabled = false;
                }

                if (!inCart) {
                    visibleCount++;
                }
            });

            wrapper.style.display = visibleCount === 0 ? "none" : "";
        });

        // console.log("Upsell UI updated. Cart product IDs:", [...cartProductIds]);
    }

    async function addUpsellProduct(variantId, cardElement) {
        // console.log("Adding upsell product, variant:", variantId);

        if (cardElement) {
            cardElement.classList.add("is-adding");
        }

        const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "X-Cart-Upsell-Internal": "true"
            },
            body: JSON.stringify({
                items: [{
                    id: Number(variantId),
                    quantity: 1
                }]
            })
        });

        const data = await response.json();
        // console.log("Upsell add response:", response.status, data);

        if (!response.ok) {
            if (cardElement) {
                cardElement.classList.remove("is-adding");
            }
            throw new Error(data.description || data.message || "Unable to add upsell product");
        }

        await afterCartChange();
    }

    async function afterCartChange() {
        // console.log("Refreshing cart...");
        const cart = await getCart();
        // console.log("Current cart:", cart);
        updateUpsellUI(cart);
        document.dispatchEvent(new CustomEvent("cart-upsell:updated", {
            detail: cart
        }));
        window.dispatchEvent(new CustomEvent("kt.cart.changed", {
            detail: cart
        }));
        await refreshCartDrawer();
    }

    async function refreshCartDrawer() {
        try {
            // console.log("Refreshing cart drawer...");
            const sectionsUrl = window.location.pathname;
            const response = await fetch(
                `${sectionsUrl}?sections=cart-count-badge,offcanvas-cart`
            );
            if (!response.ok) {
                console.warn("Cart sections request failed:", response.status);
                return;
            }
            const sections = await response.json();

            if (sections["cart-count-badge"]) {
                const badgeDoc = new DOMParser().parseFromString(
                    sections["cart-count-badge"],
                    "text/html"
                );
                document.querySelectorAll(".cart-count-badge").forEach(elem => {
                    const newBadge = badgeDoc.querySelector(".cart-count-badge");
                    if (newBadge) {
                        elem.replaceWith(newBadge.cloneNode(true));
                    }
                });
            }
            if (sections["offcanvas-cart"]) {
                const cartDoc = new DOMParser().parseFromString(
                    sections["offcanvas-cart"],
                    "text/html"
                );
                document.querySelectorAll(".cart-container").forEach(elem => {
                    const newCart = cartDoc.querySelector("cart-container");
                    if (newCart) {
                        elem.replaceWith(newCart.cloneNode(true));
                    }
                });
            }

            window.dispatchEvent(new CustomEvent("kt.cart.reloaded"));

            // console.log("Cart drawer refreshed (sections update)");
        } catch (error) {
            console.error("Cart drawer refresh error:", error);
        }
    }


    function getSelectedProductUpsells() {
        const wrapper = document.querySelector(".cart-upsell-wrapper--product");
        if (!wrapper) {
            // console.log("No product upsell wrapper found");
            return [];
        }
        const selected = [];
        wrapper.querySelectorAll(".cart-upsell__checkbox:checked").forEach(checkbox => {
            const variantId = checkbox.dataset.upsellVariant;
            const productId = checkbox.dataset.upsellProduct;
            if (variantId) {
                selected.push({ variantId: Number(variantId), productId });
            }
        });
        // console.log("Product page selected upsells:", selected);
        return selected;
    }

    async function addProductWithUpsells(form, options = {}) {
        // console.log("Product Add To Cart intercepted (with upsells)", options);

        const variantInput = form.querySelector('[name="id"]');
        if (!variantInput) {
            throw new Error("Product variant ID not found");
        }

        const productId = Number(variantInput.value);
        const quantityInput = form.querySelector('[name="quantity"]');
        const quantity = Number(quantityInput?.value) || 1;
        const selectedUpsells = getSelectedProductUpsells();

        // console.log("Main product:", productId, "Qty:", quantity);
        // console.log("Selected upsells:", selectedUpsells);

        const items = [{
            id: productId,
            quantity: quantity
        }];

        const cart = await getCart();
        const cartProductIds = new Set(
            cart.items.map(item => String(item.product_id))
        );

        selectedUpsells.forEach(({ variantId, productId: upPid }) => {
            if (!cartProductIds.has(String(upPid))) {
                items.push({
                    id: variantId,
                    quantity: 1
                });
            }
        });

        // console.log("Final items going to Shopify:", items);

        const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "X-Cart-Upsell-Internal": "true"
            },
            body: JSON.stringify({ items })
        });

        const data = await response.json();
        // console.log("Product + upsells add response:", response.status, data);

        if (!response.ok) {
            throw new Error(data.description || data.message || "Unable to add product");
        }

        document.querySelectorAll(".cart-upsell-wrapper--product .cart-upsell__checkbox").forEach(cb => {
            cb.checked = false;
        });

        if (options.redirectToCheckout) {
            window.location.href = "/checkout";
            return;
        }

        await afterCartChange();

        setTimeout(() => {
            const offcanvas = document.querySelector("#offcanvas-cart");
            if (offcanvas && window.bootstrap) {
                window.bootstrap.Offcanvas.getOrCreateInstance(offcanvas).show();
            }
        }, 100);
    }

    function bindEvents() {
        // console.log("Binding Cart Upsell events");

        document.addEventListener("change", async function (event) {
            const checkbox = event.target;
            if (!checkbox.matches(".cart-upsell__checkbox")) {
                return;
            }

            const wrapper = checkbox.closest(".cart-upsell-wrapper");
            if (!wrapper) {
                return;
            }

            const isProductPage = wrapper.classList.contains("cart-upsell-wrapper--product");

            if (isProductPage) {
                const card = checkbox.closest(".cart-upsell__card");
                if (card) {
                    card.classList.toggle("is-selected", checkbox.checked);
                }
                // console.log("UPSELL TOGGLE (product page, selection only):", checkbox.dataset.upsellVariant, checkbox.checked);
                return;
            }

            if (!checkbox.checked) {
                return;
            }

            const card = checkbox.closest(".cart-upsell__card");
            if (!card) {
                return;
            }

            const variantId = checkbox.dataset.upsellVariant;
            if (!variantId) {
                console.warn("Upsell checkbox missing data-upsell-variant");
                return;
            }

            // console.log("UPSELL TOGGLE (cart drawer, adding):", variantId);
            checkbox.disabled = true;

            try {
                await addUpsellProduct(variantId, card);
            } catch (error) {
                console.error("UPSELL ADD ERROR:", error);
                checkbox.checked = false;
                checkbox.disabled = false;
                if (card) {
                    card.classList.remove("is-adding");
                }
            }
        },
            true);

        document.addEventListener("submit", async function (event) {
            const form = event.target;
            if (!form.matches('form[action*="/cart/add"]')) {
                return;
            }

            // console.log("Product form submit detected");
            const selectedUpsells = getSelectedProductUpsells();

            if (selectedUpsells.length === 0) {
                // console.log("No upsell selected — normal ATC");
                return;
            }

            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            const button = form.querySelector('[type="submit"]');
            if (button) {
                button.disabled = true;
            }

            try {
                await addProductWithUpsells(form);
            } catch (error) {
                console.error("PRODUCT + UPSELL ERROR:", error);
            } finally {
                if (button) {
                    button.disabled = false;
                }
            }
        },
            true);

        document.addEventListener("click", async function (event) {
            const dynamicBtn = event.target.closest(
                '.shopify-payment-button__button, [data-shopify="payment-button"] button, [data-shopify="payment-button"], button[name="checkout"], shop-pay-button'
            );
            if (!dynamicBtn) {
                return;
            }

            const form = dynamicBtn.closest("form[action*='/cart/add']");
            if (!form) {
                return;
            }

            const selectedUpsells = getSelectedProductUpsells();
            if (selectedUpsells.length === 0) {
                console.log("Dynamic checkout — no upsell selected, native behavior");
                return;
            }

            console.log("Dynamic checkout button intercepted (upsells selected)");
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            if (dynamicBtn.disabled !== undefined) {
                dynamicBtn.disabled = true;
            }

            try {
                await addProductWithUpsells(form, { redirectToCheckout: true });
            } catch (error) {
                console.error("BUY NOW + UPSELL ERROR:", error);
                if (dynamicBtn.disabled !== undefined) {
                    dynamicBtn.disabled = false;
                }
            }
        },
            true);

        document.addEventListener("change", async function (event) {
            const checkbox = event.target.closest(".hamper-child__checkbox");
            if (!checkbox) {
                return;
            }

            if (checkbox.checked) {
                return;
            }

            const key = checkbox.dataset.hamperChildKey;
            if (!key) {
                return;
            }

            checkbox.disabled = true;
            try {
                await removeHamperChild(key);
            } catch (error) {
                console.error("HAMPER CHILD REMOVE ERROR:", error);
                checkbox.checked = true;
            } finally {
                checkbox.disabled = false;
            }
        },
            true);

        document.addEventListener("click", async function (event) {
            const removeBtn = event.target.closest(".hamper-child__remove");
            if (!removeBtn) {
                return;
            }

            const key = removeBtn.dataset.hamperChildKey;
            if (!key) {
                return;
            }

            removeBtn.disabled = true;
            try {
                await removeHamperChild(key);
            } catch (error) {
                console.error("HAMPER CHILD REMOVE ERROR:", error);
                removeBtn.disabled = false;
            }
        },
            true);
    }

    /* =========================================================
       HAMPER (parent product + linked child products)
    ========================================================= */

    async function removeCartLineByKey(key) {
        const response = await fetch("/cart/change.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "X-Cart-Upsell-Internal": "true"
            },
            body: JSON.stringify({ id: key, quantity: 0 })
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.description || data.message || "Unable to remove item");
        }

        return data;
    }

    async function cleanupOrphanedHamperLines(cart) {

        const hamperParents = cart.items.filter(isHamperParent);
        const hamperChildren = cart.items.filter(isHamperChild);

        if (hamperParents.length === 0 && hamperChildren.length === 0) {
            return cart;
        }

        const updates = {};

        hamperChildren.forEach((child) => {
            const parentId = child.properties[HAMPER_CONFIG.parentKey];
            const parentExists = hamperParents.some(
                (parent) => parent.properties[HAMPER_CONFIG.idKey] === parentId
            );
            if (!parentExists) {
                updates[child.key] = 0;
            }
        });

        hamperParents.forEach((parent) => {
            const parentId = parent.properties[HAMPER_CONFIG.idKey];
            const hasRemainingChildren = hamperChildren.some((child) => {
                return (
                    child.properties[HAMPER_CONFIG.parentKey] === parentId &&
                    updates[child.key] !== 0
                );
            });
            if (!hasRemainingChildren) {
                updates[parent.key] = 0;
            }
        });

        if (Object.keys(updates).length === 0) {
            return cart;
        }

        // console.log("Cleaning up orphaned hamper lines:", updates);

        const response = await fetch("/cart/update.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "X-Cart-Upsell-Internal": "true"
            },
            body: JSON.stringify({ updates })
        });

        const data = await response.json();

        if (!response.ok) {
            console.error("Failed to clean up hamper lines:", data);
            return cart;
        }

        return data;
    }

    async function removeHamperChild(key) {
        // console.log("Removing hamper child:", key);
        let cart = await removeCartLineByKey(key);
        cart = await cleanupOrphanedHamperLines(cart);
        updateUpsellUI(cart);
        await refreshCartDrawer();
    }

    async function handleExternalCartChange(cartFromEvent) {
        let cart = cartFromEvent || await getCart();
        updateUpsellUI(cart);

        const cleanedCart = await cleanupOrphanedHamperLines(cart);

        if (cleanedCart !== cart) {
            updateUpsellUI(cleanedCart);
            await refreshCartDrawer();
        }
    }

    function subscribeToThemeCartUpdates() {

        console.log("Subscribing to The Street theme cart events (kt.cart.*)");

        // Listen for theme's own cart change/add events
        ["kt.cart.changed", "kt.cart.added"].forEach(eventName => {
            window.addEventListener(eventName, async (event) => {
                console.log(`Theme cart event detected (${eventName}):`, event.detail);
                const cart = await getCart();
                await handleExternalCartChange(cart);
            });
        });

        // Re-bind upsell UI when theme replaces cart DOM
        window.addEventListener("kt.cart.reloaded", async () => {
            console.log("Theme cart reloaded — re-syncing upsell UI");
            const cart = await getCart();
            updateUpsellUI(cart);
        });

        // Also keep fetch interception as a safety net
        patchFetchForCartSync();
    }

    function patchFetchForCartSync() {

        if (window.__cartUpsellFetchPatched) {
            return;
        }

        window.__cartUpsellFetchPatched = true;

        const originalFetch = window.fetch;

        const CART_ENDPOINTS = [
            "/cart/add",
            "/cart/change",
            "/cart/update",
            "/cart/clear"
        ];

        window.fetch = async function (...args) {

            const response = await originalFetch.apply(this, args);

            try {

                const requestUrl =
                    typeof args[0] === "string"
                        ? args[0]
                        : (args[0]?.url || "");

                const isCartMutation = CART_ENDPOINTS.some(endpoint =>
                    requestUrl.includes(endpoint)
                );

                if (isCartMutation && response.ok) {

                    const requestInit = args[1] || {};
                    const headers = requestInit.headers || {};

                    const isInternal =
                        headers["X-Cart-Upsell-Internal"] === "true" ||
                        (typeof headers.get === "function" && headers.get("X-Cart-Upsell-Internal") === "true");

                    if (isInternal) {
                        // console.log("Skipping external-cart-sync for our own request:", requestUrl);
                    } else {

                        // console.log("Detected cart mutation via fetch:", requestUrl);

                        setTimeout(async () => {
                            const cart = await getCart();
                            await handleExternalCartChange(cart);
                        }, 300);

                    }

                }

            } catch (err) {
                console.error("Fetch interception error:", err);
            }

            return response;
        };

        // console.log("Fetch interception active for cart sync");
    }

    async function init() {
        // console.log("Cart Upsell initialized");
        bindEvents();
        subscribeToThemeCartUpdates();
        try {
            const cart = await getCart();
            updateUpsellUI(cart);
            await handleExternalCartChange(cart);
        } catch (error) {
            console.error("Initial cart error:", error);
        }
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }

    return {
        getCart,
        addUpsellProduct,
        addProductWithUpsells,
        getSelectedProductUpsells,
        removeHamperChild
    };
})();